module.exports = global["jQuery"] = require("-!/data/app/rdc-next/node_modules/expose-loader/index.js?$!/data/app/rdc-next/node_modules/source-map-loader/index.js!./jquery.js");


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/jquery/dist/jquery.js
// module id = 33
// module chunks = 48 49